import React, { useCallback, useState } from 'react';

import { Badge, Modal } from 'antd-v5';
import { MdModeComment } from 'react-icons/md';

import AdvRequirementsComments from '@modules/youthProfile/components/AdvRequirementsPage/AdvRequirementsComments';
import type { advancementTypes } from '@shared/constants';

import styles from './CommentsButton.module.scss';

interface CommentsButtonProps {
  advancementId: number;
  advancementType: advancementTypes;
  renderPhotos: boolean;
  requirementId?: number;
  requirementName?: string;
  userId: number;
  versionId: number;
}

const CommentsButton = (props: CommentsButtonProps) => {
  const {
    advancementId,
    advancementType,
    renderPhotos,
    requirementId,
    requirementName,
    versionId,
    userId,
  } = props;
  const [modalVisible, setModalVisible] = useState(false);

  const showModal = () => {
    setModalVisible(true);
  };

  const hideModal = useCallback(() => setModalVisible(false), []);

  return (
    <>
      <Badge className={styles.commentsBadge}>
        <MdModeComment
          className={styles.commentsButtonIcon}
          onClick={showModal}
        />
      </Badge>
      <Modal
        centered
        destroyOnClose
        footer={null}
        onCancel={hideModal}
        open={modalVisible}
      >
        {/* To Do: refactor using Form Component from AntD */}
        <AdvRequirementsComments
          advancementId={advancementId}
          advancementType={advancementType}
          renderPhotos={renderPhotos}
          requirementId={requirementId}
          requirementName={requirementName}
          versionId={versionId}
          youthUserId={userId}
        />
      </Modal>
    </>
  );
};

export default CommentsButton;
